import React, { Component } from 'react'
import { FullCalendarCmp } from '../index'



class ScheduleRoute extends Component {
    render() {
        const { CalendarFunctions, InitEvents } = this.props
        return (
            <div className='m-5'>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div className='row'>
                            <div class="col-lg-8 mb-4 order-0">
                                <div class="card">
                                    <div class="d-flex align-items-end row">
                                        <div class="col-sm-12">
                                            <div class="card-body" >
                                                <div className="h-100">
                                                    <FullCalendarCmp
                                                        initEvents={InitEvents}
                                                        calendarFunctions={CalendarFunctions}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 order-2 mb-4">
                                <div class="card h-100">
                                    <div class="card-header d-flex align-items-center justify-content-between">
                                        <h5 class="card-title m-0 me-2">Eventos activos</h5>
                                    </div>
                                    <div class="card-body scrollEventsBP" >
                                        <ul class="p-0 m-0">
                                            {InitEvents && InitEvents.map((event, index) => {
                                                return (
                                                    <li class="d-flex mb-4 pb-1" /*onClick={() => GetRoutePoints(route)}*/>
                                                        <div class="avatar flex-shrink-0 mr-2 ml-2 mt-2" >
                                                            <img style={{ maxHeight: "25px", maxWidth: "25px" }}
                                                                src={require('../../images/ico/routeMap.png')} alt="User" class="rounded" />
                                                        </div>
                                                        <div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                            <div class="me-2">
                                                                <h6 class="mb-0">{event.title} </h6>
                                                                <h6 class="mb-0">{`Desde: ${event.start}. Hasta: ${event.end}`} </h6>
                                                            </div>
                                                            <div class="user-progress d-flex align-items-center gap-1 mr-2">
                                                            </div>
                                                        </div>
                                                    </li>

                                                )
                                            })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="content-backdrop fade"></div>
                </div>
            </div>
        )
    }

}

export default ScheduleRoute